<template>
  <div>
    <div
      class="row items-center q-pa-md text-white"
      :style="`background: var(--outcome-secondary); height: 80px`"
    >
      <div class="col-6">
        <b>What type of data goal would you like to create?</b>
      </div>
    </div>
    <div class="q-pa-md">
      <div style="height: 330px">
        <p class="text-accent suggestedTitle">
          Please build a data goal by choosing the below options
        </p>
        <div class="row items-center">
          <q-select
            class="q-ml-md"
            v-model="actionSelect"
            :options="actionOptions"
            dense
            filled
            dropdown-icon="mdi-chevron-down"
          >
          </q-select>
          <q-select
            class="q-ml-md"
            v-model="selectedData"
            :options="[]"
            dense
            map-options
            emit-value
            option-label="name"
            option-value="id"
            filled
            dropdown-icon="mdi-chevron-down"
          >
          </q-select>
        </div>
        <div class="row items-center q-mt-md">
          <span class="goalBuilder__sentence"> in </span>

          <q-input
            class="q-mx-sm"
            v-model="formattedBaselineYear"
            dense
            filled
            style="width: 100px"
            @change="updateSelectedData"
          >
            <template v-slot:append>
              <q-icon name="mdi-chevron-down"></q-icon>
            </template>
            <template>
              <q-popup-proxy
                ref="yearProxyBaseline"
                transition-show="scale"
                transition-hide="scale"
                :breakpoint="0"
                v-model="yearBaselineDialog"
              >
                <q-date
                  minimal
                  v-model="selectedBaselineYear"
                  default-view="Years"
                  emit-immediately
                  @input="checkCalendar"
                >
                </q-date>
              </q-popup-proxy>
            </template>
          </q-input>
          <span class="goalBuilder__sentence"> by </span>

          <q-input
            style="width: 120px"
            class="q-ml-sm"
            v-model="reductionPercentage"
            @input="initStats"
            dense
            filled
            type="number"
            hide-bottom-space
            :rules="[
              (val) => !!val || 'Field is required',
              (val) => !isNaN(parseFloat(val)) || 'Value must be a number',
            ]"
          >
            <template v-slot:append>
              <span
                :style="`
                    font-family: 'Montserrat';
                    font-style: normal;
                    font-weight: 900!important;
                    font-size: 14px;
                  `"
              >
                {{ isUnit ? selectedData.unit : "%" }}
              </span>
            </template>
          </q-input>

          <span class="goalBuilder__sentence q-ml-sm"> by </span>
          <q-input
            class="q-ml-sm"
            v-model="formattedSelectedYear"
            dense
            filled
            style="width: 100px"
          >
            <template v-slot:append>
              <q-icon name="mdi-chevron-down"></q-icon>
            </template>
            <template>
              <q-popup-proxy
                ref="yearProxy"
                transition-show="scale"
                transition-hide="scale"
                :breakpoint="0"
                v-model="yearDialog"
              >
                <q-date
                  minimal
                  v-model="selectedYear"
                  default-view="Years"
                  emit-immediately
                  @input="checkCalendar"
                >
                </q-date>
              </q-popup-proxy>
            </template>
          </q-input>
        </div>
        <div class="row justify-between">
          <div
            style="height: 2px; width: 516px"
            class="bg-grey-4 q-mx-auto q-my-lg"
          ></div>
        </div>
        <!--FIRST ROW OF IMPACT INPUT-->
        <div class="row">
          <div class="col-auto" style="width: 150px">
            <span
              class="goalBuilder__stats__title"
              :style="`color:${outcomeColor}`"
            >
              Baseline
            </span>
          </div>
          <div class="col">
            <span
              class="goalBuilder__stats__title"
              :style="`color:${outcomeColor}`"
            >
              Target
            </span>
          </div>
          <div class="col">
            <span
              class="goalBuilder__stats__title"
              :style="`color:${outcomeColor}`"
            >
              Difference of
            </span>
          </div>
        </div>
        <div class="row items-center">
          <div class="col-auto" style="width: 150px">
            <div style="margin-bottom: 5px">
              <span class="goalBuilder__stats__font">
                {{ selectedData.total | numberFormat }}</span
              >
              <span class="goalBuilder__stats__unit">
                ({{ selectedData.unit }})
              </span>
            </div>
          </div>
          <div class="col q-pr-md">
            <div>
              <q-input
                type="number"
                filled
                v-model="target"
                dense
                @input="onTargetChange"
                :rules="[
                  (val) => !!val || 'Field is required',
                  (val) => !isNaN(parseFloat(val)) || 'Value must be a number',
                ]"
              >
                <template v-slot:append>
                  <span
                    :style="`
                    font-family: 'Montserrat';
                    font-style: normal;
                    font-weight: 900!important;
                    font-size: 11.9913px;
                    color: ${outcomeColor} !important;
                  `"
                  >
                    ({{ selectedData.unit }})</span
                  >
                </template>
              </q-input>
            </div>
          </div>
          <div class="col q-pr-md">
            <div>
              <q-input
                type="number"
                filled
                v-model="reduction"
                dense
                @input="onReductionChange"
                :rules="[
                  (val) => !!val || 'Field is required',
                  (val) => !isNaN(parseFloat(val)) || 'Value must be a number',
                ]"
              >
                <template v-slot:append>
                  <span
                    :style="`
                    font-family: 'Montserrat';
                    font-style: normal;
                    font-weight: 900!important;
                    font-size: 11.9913px;
                    color: ${outcomeColor} !important;
                  `"
                  >
                    ({{ selectedData.unit }})
                  </span>
                </template>
              </q-input>
            </div>
          </div>
        </div>
        <!--SECOND ROW OF IMPACT (SPECIAL UNITS e.g tCO2-e)-->
        <div
          class="row"
          v-if="selectedGoal && selectedGoal.outcomesSources_outcomes_id == 1"
        >
          <div class="col-auto" style="width: 150px">
            <span
              class="goalBuilder__stats__title"
              :style="`color:${outcomeColor}`"
            >
              Baseline
            </span>
          </div>
          <div class="col">
            <span
              class="goalBuilder__stats__title"
              :style="`color:${outcomeColor}`"
              style="margin-right: 165px"
            >
              Target
            </span>
          </div>
          <div class="col">
            <span
              class="goalBuilder__stats__title"
              :style="`color:${outcomeColor}`"
            >
              Difference of
            </span>
          </div>
        </div>
        <div
          class="row items-center"
          v-if="
            selectedData &&
            selectedData.emissionsFactor &&
            selectedOutcome.usesFactor
          "
        >
          <div class="col-auto" style="width: 150px">
            <div style="margin-bottom: 5px">
              <span class="goalBuilder__stats__font"
                >{{ getCurrentEmissions() | numberFormat }}
              </span>
              <span class="goalBuilder__stats__unit">
                {{ factorUnit(selectedData.emissionsFactor[0].unit) }}
              </span>
            </div>
          </div>
          <div class="col q-pr-md">
            <div>
              <q-input
                type="number"
                filled
                v-model="emissionTarget"
                :disable="true"
                dense
                @input="onTargetChange"
                :rules="[
                  (val) => !!val || 'Field is required',
                  (val) => !isNaN(parseFloat(val)) || 'Value must be a number',
                ]"
              >
                <template v-slot:append>
                  <span
                    :style="`
                    font-family: 'Montserrat';
                    font-style: normal;
                    font-weight: 900!important;
                    font-size: 11.9913px;
                    color: ${outcomeColor} !important;
                  `"
                  >
                    (tCO2-e)</span
                  >
                </template>
              </q-input>
            </div>
          </div>
          <div class="col q-pr-md">
            <div>
              <q-input
                type="number"
                filled
                :disable="true"
                v-model="emissionReduction"
                dense
                :rules="[
                  (val) => !!val || 'Field is required',
                  (val) => !isNaN(parseFloat(val)) || 'Value must be a number',
                ]"
              >
                <template v-slot:append>
                  <span
                    :style="`
                    font-family: 'Montserrat';
                    font-style: normal;
                    font-weight: 900!important;
                    font-size: 11.9913px;
                    color: ${outcomeColor} !important;
                  `"
                  >
                    (tCO2-e)</span
                  >
                </template>
              </q-input>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="!isUpdating">
        <div class="col">
          Our data goal builder is specifically designed so that we can show you
          controlled reporting and trends that are unique to this source
        </div>
        <div class="col-auto">
          <q-btn
            :style="`background-color: ${outcomeColor}`"
            class="button q-ml-sm"
            no-caps
            @click="addCustomGoal(false)"
          >
            <span class="buttonText text-white">Add to my plan</span>
          </q-btn>
        </div>
      </div>
      <div class="row justify-end" v-else>
        <q-btn
          :style="`background-color: ${outcomeColor}`"
          class="button q-ml-sm"
          no-caps
          @click="saveCustomGoal(true, false)"
        >
          <span class="buttonText text-white">Remove from my plan</span>
        </q-btn>
        <q-btn
          :style="`background-color: ${outcomeColor}`"
          class="button q-ml-sm"
          no-caps
          @click="saveCustomGoal(false, false)"
        >
          <span class="buttonText text-white">Update Goal</span>
        </q-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    selectedData: {
      default: null,
    },
    outcomeColor: {
      type: String,
      default: null,
    },
  },
  watch: {
    $route: {
      handler() {
        this.handleRoute();
      },
      deep: true,
    },
    actionSelect: function () {
      this.initStats();
    },
    selectedBaselineYear: function () {
      this.updateSelectedData();
    },
    selectedData: function () {
      this.initStats();
    },
    selectedGoal: function () {
      this.reductionPercentage = this.selectedGoal.reductionPercentage;

      this.selectedBaselineYear = this.$moment(
        this.selectedGoal.baselineDate
      ).format("YYYY");
      this.selectedYear = this.$moment(this.selectedGoal.due_at).format("YYYY");

      this.isUpdating = true;
      if (this.selectedGoal.isUnit) {
        if (this.selectedGoal.isUnit == 1) {
          this.isUnit = true;
        } else {
          this.isUnit = false;
        }
      }
      this.initStats();
    },
  },
  mounted() {
    this.handleRoute();
  },
  computed: {
    ...mapGetters({
      selectedGoal: "goals/selectedGoal",
      selectedOutcome: "general/selectedOutcome",
    }),

    formattedSelectedYear: {
      set() {},
      get() {
        if (typeof this.selectedYear === "string") {
          return this.selectedYear.split("/")[0];
        } else {
          return this.selectedYear;
        }
      },
    },
    formattedBaselineYear: {
      set() {},
      get() {
        if (typeof this.selectedBaselineYear === "string") {
          return this.selectedBaselineYear.split("/")[0];
        } else {
          return this.selectedBaselineYear;
        }
      },
    },
  },
  data: () => ({
    actionSelect: "Reduce",
    actionOptions: ["Reduce", "Increase"],
    reductionPercentage: 5,
    target: "",
    reduction: "",
    yearDialog: false,
    yearBaselineDialog: false,
    selectedYear:
      new Date(
        new Date().setFullYear(new Date().getFullYear() + 1)
      ).getFullYear() + "/01/01",
    selectedBaselineYear:
      new Date(new Date().setFullYear(new Date().getFullYear())).getFullYear() +
      "/01/01",
    isUpdating: false,
    emissionReduction: "",
    emissionTarget: "",

    isUnit: false,
  }),
  methods: {
    handleRoute() {
      if (
        !this.$route.params.hasOwnProperty("goalID") &&
        !this.selectedData.goalBuilderGoal
      ) {
        if (!this.selectedData.negative) {
          this.actionSelect = "Increase";
        }
        this.initStats();
      }
    },
    async saveCustomGoal(isDelete = false, writeYourOwn = false) {
      let payload = {
        ...this.selectedGoal,
      };
      payload["action"] = this.actionSelect;
      payload["due_at"] =
        typeof this.selectedYear === "number" || this.selectedYear.length == 4
          ? this.selectedYear + "/01/01"
          : this.selectedYear;
      payload["reductionPercentage"] = parseFloat(this.reductionPercentage);
      payload["baselineDate"] =
        this.selectedBaselineYear.length == 4
          ? this.selectedBaselineYear + "/01/01"
          : this.selectedBaselineYear;
      payload["baselineData"] = this.selectedData.total;
      if(this.selectedOutcome.usesFactor) {
        payload["customFactorData"] = this.getCurrentEmissions(false);
      }

      if (isDelete) {
        payload = {
          ...payload,
          deleted_at: true,
        };
      }
      let result = await this.$store.dispatch("goals/save", payload);
      this.$emit("callGoalSummaryInit");
      if (result.Result == "Success") {
        this.$q.notify({
          position: "top-right",
          type: "positive",
          message: result.Response.Message,
        });
        this.closeForm();
      } else {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an Error, Please try again later",
        });
      }
    },
    async addCustomGoal(writeYourOwn = false) {
      let payload = {
        sources_id: this.selectedData.sources_id,
        action: this.actionSelect,
        due_at:
          this.selectedYear.length == 4 || typeof this.selectedYear === "number"
            ? this.selectedYear + "/01/01"
            : this.selectedYear,
        baselineDate:
          this.selectedBaselineYear.length == 4
            ? this.selectedBaselineYear + "/01/01"
            : this.selectedBaselineYear,
        baselineData: this.selectedData.total,
        reductionPercentage: this.reductionPercentage,
      };
      if(this.selectedOutcome.usesFactor) {
        payload.customFactorData = this.getCurrentEmissions(false);
      }
      let result = await this.$store.dispatch("goals/new", payload);
      this.closeForm();
      if (result.Result == "Success") {
        this.$q.notify({
          position: "top-right",
          type: "positive",
          message: "Goal has been added to plan",
        });
      } else {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an Error, Please try again later",
        });
      }
    },
    onTargetChange() {
      if (this.target) {
        this.reduction = this.selectedData.total - this.target;
        this.reductionPercentage =
          (this.reduction / this.selectedData.total) * 100;

        this.updateEmissionReduction();
        this.updateEmissionTarget();
      }
    },
    onReductionChange() {
      if (this.reduction) {
        this.reductionPercentage =
          (this.reduction / this.selectedData.total) * 100;
        this.target = this.selectedData.total - this.reduction;
        this.updateEmissionReduction();
        this.updateEmissionTarget();
      }
    },
    closeForm() {
      this.$emit("closeForm");
    },
    getCurrentEmissions(withFactorCalc = true) {
      if (
        this.selectedData.customEmissionsFactor &&
        this.selectedData.customEmissionsFactor.useCustom
      ) {
        return withFactorCalc
          ? this.factorCalculation(
              this.selectedData.customEmissionsFactor.totalValue
            )
          : this.selectedData.customEmissionsFactor.totalValue;
      }

      return withFactorCalc
        ? this.factorCalculation(
            this.selectedData.emissionsFactor[0].emissionsFactor *
              this.selectedData.total
          )
        : this.selectedData.emissionsFactor[0].emissionsFactor *
            this.selectedData.total;
    },
    updateEmissionReduction() {
      let currentEmissions = this.getCurrentEmissions();

      this.emissionReduction =
        currentEmissions * (this.reductionPercentage / 100);
    },
    updateEmissionTarget() {
      let currentEmissions = this.getCurrentEmissions();

      if (this.actionSelect == "Increase") {
        this.emissionTarget =
          currentEmissions +
          currentEmissions * (this.reductionPercentage / 100);
      } else {
        this.emissionTarget =
          currentEmissions -
          currentEmissions * (this.reductionPercentage / 100);
      }
    },
    initStats() {
      if (this.reductionPercentage || this.reductionPercentage == 0) {
        if (this.actionSelect == "Increase") {
          this.target =
            this.selectedData.total +
            this.selectedData.total * (this.reductionPercentage / 100);
        } else {
          this.target =
            this.selectedData.total -
            this.selectedData.total * (this.reductionPercentage / 100);
        }

        this.reduction = this.selectedData.total * (this.reductionPercentage / 100);

        if(this.selectedOutcome.usesFactor) {
          this.updateEmissionReduction();
          this.updateEmissionTarget();
        }
      }
    },
    checkCalendar(val, reason, details) {
      if (reason === "year") {
        this.$refs.yearProxy.hide();
        this.$refs.yearProxyBaseline.hide();
      }
    },

    updateSelectedData() {
      this.$store.dispatch("sources/data/loadBySourceID", {
        id: this.selectedData.sources_id,
        year: this.$moment(this.selectedBaselineYear).format("YYYY"),
      });
    },

    factorCalculation(data) {
      if (
        this.selectedOutcome &&
        this.selectedOutcome.factorMultiplier &&
        data
      ) {
        return data * this.selectedOutcome.factorMultiplier;
      } else {
        return data;
      }
    },
    factorUnit(data) {
      if (this.selectedOutcome && this.selectedOutcome.factorUnitDisplay) {
        return this.selectedOutcome.factorUnitDisplay;
      } else {
        return data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.suggestedTitle {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
}

.goalBuilder__sentence {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
}

.goalBuilder__stats__title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
}

.goalBuilder__stats__font {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 900;
  font-size: 19px;
}

.goalBuilder__stats__unit {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 900;
  font-size: 11px;
}

.headingText {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
}

.subtitle {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
}
.buttonText {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 9px;
}

.button {
}
</style>
